import type { LocationQuery } from 'vue-router';
import type { SortOption } from '@/shared/ui/AppSort/model/types/appSort';

const DEFAULT_VALUE = 'default';

const buildBaseParams = (query: LocationQuery): URLSearchParams => {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (key === 'sort' || value === undefined || value === null) return;
    if (Array.isArray(value)) {
      value.forEach((v) => v !== null && params.append(key, String(v)));
    } else {
      params.append(key, String(value));
    }
  });
  return params;
};

export const buildSortOptions = (
  path: string,
  query: LocationQuery,
  options: { id: number; label: string; value: string }[],
  defaultValue: string = DEFAULT_VALUE,
): SortOption[] => {
  const baseParams = buildBaseParams(query);

  return options.map((option) => {
    const params = new URLSearchParams(baseParams);
    if (option.value !== defaultValue) params.set('sort', option.value);
    const qs = params.toString();

    return {
      id: option.id,
      label: option.label,
      value: option.value,
      link: qs ? `${path}?${qs}` : path,
    };
  });
};
